// extracted by mini-css-extract-plugin
export default {"shadow":"Button3d_shadow__mfpZ1","edge":"Button3d_edge__NnMIC","front":"Button3d_front__jFJLa","text":"Button3d_text__BxLNS"};